import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_EMPLOYEES_SALARY_LIST);
var axios_instance_2 = get_axios_instance(api_variables.SERVICE_EMPLOYEES_UPDATE_NON_CTC);
var axios_instance_3 = get_axios_instance(api_variables.SERVICE_GET_LE_COMPONENTS);
var axios_instance_non_ctc = get_axios_instance(api_variables.SERVICE_EMPLOYEES_NON_CTC);
var axios_instance_non_ctc_bulk = get_axios_instance(api_variables.SERVICE_EMPLOYEES_BULK_NON_CTC);

var axios_instance_non_ctc_components = get_axios_instance(api_variables.SERVICE_SALARY_COMPONENT_NON_CTC);
var axios_instance_update_non_ctc = get_axios_instance(api_variables.SERVICE_UPDATE_NON_CTC);
var axios_instance_components_revision_log = get_axios_instance(api_variables.SERVICE_EMPLOYEE_COMPONENTS_REVISION_LOG);

const state = {
    data: [],
    revisionLogData: [],
    employeeData: {},
    selectedEmployeeIndex: -1,
    selectedComponentIndex: -1,
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {},
    revisionLogRecord: {},
    nonCtcComponentRecord: {}
};
const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
            return state.record;
        }
        // componentNameFromId: (state) => {
        //   for (comp of state.data)
        // }
};
const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setRevisionLogData: (state, payload) => {
        state.revisionLogData = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;

        state.selectedEmployeeIndex = payload.index;
    },

    setRecordsComponentsAdvancedSettings: (state, payload) => {
        state.record.EmployeeNonCTCComponent.salary_component[payload.index].advanced_setting =
            payload.advanced_setting;
        state.record.EmployeeNonCTCComponent.salary_component[payload.index].applicable_from =
            payload.assignedComponentsObj.applicableFrom_date;
        state.record.EmployeeNonCTCComponent.salary_component[payload.index].applicable_to =
            payload.assignedComponentsObj.applicableTo_date;
        state.record.EmployeeNonCTCComponent.salary_component[payload.index].name = payload.assignedComponentsObj.name;
        state.record.EmployeeNonCTCComponent.salary_component[payload.index].salary_component_id =
            payload.assignedComponentsObj.id;
    },

    setNonCtcComponentEditMode: (state, payload) => {
        state.nonCtcComponentRecord = payload.record;
        state.selectedComponentIndex = payload.index;
    },

    setRevisionLog: (state, payload) => {
        state.revisionLogRecord = payload.record;
    }
};

const actions = {
    async fetchNonCtcComponents({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_non_ctc.get(``, {
                params: {
                    employee_id: payload
                }
            });

            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchComponentsRevisionLog({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_components_revision_log.get(``, {
                params: {
                    component_id: payload.component_id,
                    employee_id: payload.employee_id
                }
            });

            commit('setFetching', false);
            if (res.status == 200) {
                commit('setRevisionLogData', res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchEmployeesNonCtcComponents({ commit }, payload) {
        //
        try {
            commit('setFetching', true);
            let res = await axios_instance.post('/', payload);

            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchLegalEntitySalaryComponents({ commit }, payload) {
        //
        try {
            commit('setFetching', true);
            let res = await axios_instance_3.get('/', {
                params: {
                    le_id: payload
                }
            });

            commit('setFetching', false);
            if (res.status == 200) {
                //commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async updateNonCtcComponents({ commit }, payload) {
        //
        try {
            commit('setFetching', true);
            let res = await axios_instance_2.post('/', payload);

            commit('setFetching', false);
            if (res.status == 200) {
                //commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        //
        try {
            commit('setFetching', true);
            let res = await axios_instance_non_ctc.post('/', payload);

            commit('setFetching', false);
            if (res.status == 200) {
                //commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        //
        try {
            commit('setFetching', true);
            let res = await axios_instance_non_ctc.put('/', payload);

            commit('setFetching', false);
            if (res.status == 200) {
                //commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit('setEditMode', payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async updateRecordsComponentsAdvancedSettings({ commit }, payload) {
        try {
            commit('setRecordsComponentsAdvancedSettings', payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeEmployeeNonCtcComponentEditMode({ commit }, payload) {
        try {
            commit('setNonCtcComponentEditMode', payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async setSelectedRevisionLog({ commit }, payload) {
        try {
            commit('setRevisionLog', payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
